import { render, staticRenderFns } from "./Attachment.vue?vue&type=template&id=20b8bae0&"
import script from "./Attachment.vue?vue&type=script&lang=js&"
export * from "./Attachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports